import angular from 'angular';
import AmazonPayController from './amazonpay.controller';

let AmazonPay = angular
    .module('AmazonPay', [])
    .controller('AmazonPayController', AmazonPayController);

export default AmazonPay;

